import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import { Token } from '../models/token.js'

const serviceSource = 'droidmap.backend.token-service'

export const TokenCreated = new BaseEventBuilder<Token, 'Token Created'>(
  serviceSource,
  'Token Created',
)

export const TokenRevoked = new BaseEventBuilder<
  Pick<
    Token,
    | 'id'
    | 'userId'
    | 'orgId'
    | 'projectId'
    | 'resourceScope'
    | 'resourceIds'
    | 'tokenType'
    | 'revokedAt'
  >,
  'Token Revoked'
>(serviceSource, 'Token Revoked')
